<div>
  <div id="outputGantt" class="mermaid" #outputGantt>
  </div>

  @if (diagramText) {
    <pre>
      {{diagramText}}
    </pre>
  }

</div>